import { FastField } from 'formik';

interface HiddenProps {
  readonly name: string;
}

export const Hidden: React.FC<HiddenProps & React.HTMLAttributes<HTMLInputElement>> = ({
  id, name,
  ...restProps
}) => (
  <FastField
    name={name}
  >
    {() => (
      <input
        id={id || name}
        name={name}
        type="hidden"
        {...restProps}
      />
    )}
  </FastField>
);
